import React from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import {
  GridCardVariant,
  SaleEventFooterVariant,
  TradeState
} from '../../../../_shared/types/trade';
import { StyledTradeCardContainer } from '../../../TradeCard/GridTradeCard/Styles';

import {
  StyledSaleEventEndCardContainer,
  StyledSaleEventEndCard,
  StyledHeader,
  StyledJumpToStart
} from './Styles';

const propTypes = {
  position: Proptypes.string.isRequired,
  tradeState: Proptypes.oneOf([TradeState.upcoming, TradeState.active])
    .isRequired,
  eventVariant: Proptypes.oneOf([
    SaleEventFooterVariant.COMPLETE,
    SaleEventFooterVariant.CONTINUED
  ]).isRequired,
  onJumpClick: Proptypes.func.isRequired
};

const GridSaleEventFooter = ({
  position,
  tradeState,
  eventVariant,
  onJumpClick
}) => (
  <StyledTradeCardContainer
    variant={GridCardVariant.EVENT_END}
    position={position}
    tradeState={tradeState}
  >
    <StyledSaleEventEndCardContainer>
      <StyledSaleEventEndCard>
        <StyledHeader>
          {eventVariant === SaleEventFooterVariant.CONTINUED ? (
            <FormattedMessage id="list.saleEvent.event.continued" />
          ) : (
            <FormattedMessage id="list.saleEvent.end.of.event" />
          )}
        </StyledHeader>
        <StyledJumpToStart onClick={onJumpClick}>
          <FormattedMessage id="list.saleEvent.start.of.event" />
        </StyledJumpToStart>
      </StyledSaleEventEndCard>
    </StyledSaleEventEndCardContainer>
  </StyledTradeCardContainer>
);

GridSaleEventFooter.propTypes = propTypes;

export default GridSaleEventFooter;
